module.exports = __webpack_public_path__ + "static/media/english-for-real-life.2c26b79c.png";